import React from "react";

import { Modal } from "@shared/components";
import { useTranslate } from "@refinedev/core";

import { ModuleForm } from "../ModuleForm";
import { EditModuleModalProps } from "./types";
import { useEditModuleModal } from "./controller";

export const EditModuleModal = React.memo(({ modalRef, onRefetch }: EditModuleModalProps) => {
  const translate = useTranslate();

  const { methods, handleSubmit, isPending } = useEditModuleModal({
    modalRef,
    onRefetch
  });

  return (
    <Modal
      ref={modalRef}
      title={translate("agreement_modules_admin.edit_title")}
      onConfirm={handleSubmit}
      methods={methods}
      isPending={isPending}
    >
      <ModuleForm />
    </Modal>
  );
});
